import { applyMiddleware, createStore } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import rootReducer from './reducers'

const configureStore = () => {
  const logger = createLogger({
    collapsed: true,
    predicate: () => process.env.NODE_ENV === 'development'
  })

  const store = createStore(
    rootReducer,
    {},
	    composeWithDevTools(
      applyMiddleware(thunk as any, logger as any)
    )
  )
  return store
}

export default configureStore
